import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { FocusAreas } from '../components/FocusAreas';
import { Leadership } from '../components/Leadership';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-white selection:bg-navy/10 selection:text-navy" data-id="element-61">
      <Hero data-id="element-62" />
      <About data-id="element-63" />
      <FocusAreas data-id="element-64" />
      <Leadership data-id="element-65" />
      <Contact data-id="element-66" />
      <Footer data-id="element-67" />
    </main>;
}